<!-- eslint-disable @intlify/vue-i18n/no-raw-text -->
<template>
  <f7-block>
    <p>Muestra que no hay resultados</p>
    <ol>
      <li>No permite cambiar el icono o el texto</li>
    </ol>
    <UCInformationWithoutSearchRecord />
  </f7-block>
</template>

<script>
import UCInformationWithoutSearchRecord from '@/components/common/UCInformationWithoutSearchRecord.vue';

export default {
  name: 'TestUCInformationWithoutSearchRecord',
  components: {
    UCInformationWithoutSearchRecord,
  },
};
</script>
